import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import "./i18n";
import "./Components/Css/loading.scss";

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename={"/monitoring"}>
      <Suspense fallback={<div></div>}>
        <App />
      </Suspense>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);
